import type { AudienceReach } from '../../api/client.ts';

const ROWS: Array<{ key: keyof AudienceReach['reachable']; label: string }> = [
  { key: 'push_android', label: 'Android push' },
  { key: 'push_ios', label: 'iOS push' },
  { key: 'card', label: 'Content Cards' },
  { key: 'iam', label: 'In-app messages' },
  { key: 'any', label: 'Any channel' },
];

export const formatCount = (n: number) => n.toLocaleString('en-US');

/**
 * Reachable users per channel (BB-44). Push needs notifications shown, an active token and no unsubscribe; cards and
 * in-app messages need a visit within the environment's activity window. A user reachable through several channels is
 * counted in each, so the channels add up to more than «Any channel».
 */
export function ChannelReachBreakdown({ reachable, estimated }: { reachable: AudienceReach['reachable']; estimated: boolean }) {
  return (
    <table aria-label="Reachable users by channel">
      <thead>
        <tr>
          <th scope="col">Channel</th>
          <th scope="col">{estimated ? 'Estimated reachable users' : 'Reachable users'}</th>
        </tr>
      </thead>
      <tbody>
        {ROWS.map((row) => (
          <tr key={row.key}>
            <th scope="row">{row.label}</th>
            <td>{formatCount(reachable[row.key])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
